import { useState } from 'react';

import { Grid } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateRangePicker, MultiInputDateRangeField } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { ptBR } from 'date-fns/locale';

import { StoreAutoComplete } from 'components/autocompletes';
import { Filter } from 'components/filter';
import { TituloStatusAutoComplete } from 'pages/financeiro/titulo/components/atoms/TituloStatusAutoComplete';
import { FilterValuesProps } from 'hooks/useFilter';

export function TituloFilter() {
    const [filterLoja, setFilterLoja] = useState<FilterValuesProps>({
        property: 'cdLoja',
        operator: 'eq',
        value: null,
        idProperty: 'cdLoja',
        required: 'Loja é obrigatória',
    });

    const [filterStatus, setFilterStatus] = useState<FilterValuesProps>({
        property: 'dsStatus',
        operator: 'eq',
        value: null,
        idProperty: 'tpStatus',
        required: 'Situação é obrigatório',
    });

    const [filterInterval, setFilterInterval] = useState<FilterValuesProps>({
        property: 'dtVencimento',
        operator: 'bt',
        startDate: null,
        endDate: null,
        required: 'Intervalo de vencimento é obrigatório',
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterLoja, setter: setFilterLoja },
                { value: filterStatus, setter: setFilterStatus },
                { value: filterInterval, setter: setFilterInterval },
            ]}
        >
            <Grid size={{ lg: 4 }}>
                <StoreAutoComplete
                    size="small"
                    value={filterLoja.value}
                    onChange={(e, value) => setFilterLoja((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>

            <Grid size={{ lg: 3 }}>
                <TituloStatusAutoComplete
                    label="Situacão"
                    size="small"
                    value={filterStatus.value}
                    onChange={(e, value) => setFilterStatus((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>

            <Grid sx={{ width: '100%' }} size={{ lg: 5 }}>
                <LocalizationProvider
                    adapterLocale={ptBR}
                    dateAdapter={AdapterDateFns}
                    localeText={{ start: 'Vencimento Início', end: 'Vencimento Fim' }}
                >
                    <DateRangePicker
                        value={[filterInterval.startDate ?? null, filterInterval.endDate ?? null]}
                        onChange={([startDate, endDate]) => {
                            setFilterInterval((oldState: FilterValuesProps) => ({
                                ...oldState,
                                startDate,
                                endDate,
                            }));
                        }}
                        slots={{ field: MultiInputDateRangeField }}
                        slotProps={{
                            field: { dateSeparator: 'até' },
                            textField: { autoComplete: 'off', size: 'small' },
                        }}
                    />
                </LocalizationProvider>
            </Grid>
        </Filter>
    );
}
